import React from 'react'
import './OurStory.css'

export default function OurStory() {
  return (
    <div className="OurStory">
      <div className="OurStory-container">
        <h2>Our Story</h2>
        <div className="OurStory-content">
            <p>
                RaStegHub was founded with a simple belief: technology should be purposeful, accessible, and capable 
                of creating meaningful impact. Too often, businesses invest in digital solutions that fail to address 
                their real challenges, while great ideas remain unrealized because the right technical support is out 
                of reach. We set out to change that.
                <br />
                <br />
                From the beginning, our vision has been to build more than websites or software. We wanted to create 
                a company that develops digital systems and products that solve real-world problems, streamline 
                operations, and help businesses grow with confidence. Every solution we create is driven by 
                understanding; taking the time to learn our clients' goals, challenges, and vision before designing 
                technology that truly fits their needs.
            </p>
            <p>
                As we continue to grow, RaStegHub is evolving beyond custom software development into a product-driven
                technology company. Alongside delivering tailored solutions for clients, we are investing in innovative
                products that empower businesses through automation, artificial intelligence, data-driven insights, and
                scalable cloud technologies. This dual focus enables us to create lasting value not only for individual 
                clients but for the wider business community.
                <br />
                <br />
                Today, RaStegHub is building for the future; one where technology is an enabler of innovation, efficiency, 
                and opportunity. Every project, every product, and every partnership brings us closer to that vision: 
                empowering people and organizations with digital solutions that are reliable, scalable, and built to make 
                a lasting impact.
            </p>
        </div>
      </div>
    </div>
  )
}
